/* CYL Shiloh 2+1 cart-drawer hint (July 2026 campaign).
   The drawer's _render() rebuilds .cd-body innerHTML from JS templates on
   every cart:updated, wiping Liquid-rendered rows, so this hint is injected
   client-side (same pattern as cyl-pendant-guard.js). Products:
   14998952935791 (Shiloh Pottery Shard), 15015528628591 (Handles).
   Teardown with the campaign: remove this file and its script tag in
   sections/cart-drawer.liquid. */
(function () {
  var IDS = [14998952935791, 15015528628591];
  var HINT_ID = 'cyl-shiloh-hint';

  function render(cart) {
    var existing = document.getElementById(HINT_ID);
    if (existing) existing.remove();
    if (!cart || !cart.items || !cart.items.length) return;
    var host = document.querySelector('#cart-drawer .cd-items');
    if (!host) return;
    var qty = cart.items.reduce(function (s, it) {
      return s + (IDS.indexOf(it.product_id) !== -1 ? it.quantity : 0);
    }, 0);
    if (qty < 1 || qty >= 3) return;
    var need = 3 - qty;
    var div = document.createElement('div');
    div.id = HINT_ID;
    div.className = 'cd-item';
    div.style.cssText = 'background:#F5F1E8;border:1px solid #B8956A;padding:10px 14px;display:flex;align-items:center;gap:10px;';
    div.innerHTML =
      '<div style="flex:none;background:#4DBDC8;color:#FFFFFF;font-family:Montserrat,Arial,sans-serif;font-weight:700;font-size:12px;letter-spacing:0.5px;padding:6px 8px;">2+1</div>' +
      '<div style="font-family:Heebo,Arial,sans-serif;font-size:13px;color:#3E2723;min-width:0;">' +
      '<a href="/collections/the-shiloh-collection" style="color:#3E2723;">' + need + ' more</a> and the lowest priced is free</div>';
    host.appendChild(div);
  }

  document.addEventListener('cart:updated', function (e) {
    render(e.detail && e.detail.cart);
  });

  function boot() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
